export const vPattern = (rule, val) => {
  if (!rule.pattern || !val) return null;
  return rule.pattern.test(String(val)) ? null : rule.message || null;
};
